import './style.scss'
import { ReactComponent as Arrow } from 'assets/icons/button/arrow.svg';

const HideButton = ({ text, onClick, isOpen }) => {

    const handleButtonClick = () => {
        if (onClick) {
            onClick();
        }
    };

    return (
        <button className={`hide-button ${isOpen ? "open" : ""}`} onClick={handleButtonClick}><span>{text}</span> <Arrow className='arrow' /></button>
    );
}

export default HideButton;